<template>
  <div id="customer-combined-chart" style="height: 400px;">
    <!-- 无数据时显示提示 -->
    <div v-if="!customerData.length" class="empty-tip">
      暂无数据可展示
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    customerData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    customerData: {
      deep: true,
      handler() {
        this.updateChart()
      }
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById('customer-combined-chart'))
      this.updateChart()
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    formatAmountUnit(val) {
      if (val >= 1e8) {
        return (val / 1e8).toFixed(1) + '亿'
      } else if (val >= 1e4) {
        return (val / 1e4).toFixed(1) + '万'
      } else {
        return val
      }
    },
    updateChart() {
      if (!this.chart) return

      if (!this.customerData.length) {
        this.chart.clear()
        return
      }

      // 缓存原始数据，避免 formatter 中 this 丢失
      const rawData = this.customerData

      const names = rawData.map(item =>
          item.customerName.length > 6 ? item.customerName.slice(0, 6) + '…' : item.customerName
      )
      const orderCounts = rawData.map(item => item.orderCount)
      const totalAmounts = rawData.map(item => item.totalAmount)

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            if (!params.length) return ''
            const index = params[0].dataIndex
            const fullName = rawData[index].customerName || ''
            const order = params.find(p => p.seriesName === '订单数')
            const amount = params.find(p => p.seriesName === '消费金额')

            return `${fullName}<br/>订单数: ${order ? order.value : 0}<br/>消费金额: ¥${amount ? amount.value.toLocaleString() : 0}`
          }
        },
        legend: {
          data: ['订单数', '消费金额']
        },
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: {
            interval: 0,
            rotate: 90
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '订单数',
            position: 'left'
          },
          {
            type: 'value',
            name: '消费金额',
            position: 'right',
            axisLabel: {
              formatter: val => this.formatAmountUnit(val)
            }
          }
        ],
        series: [
          {
            name: '订单数',
            type: 'bar',
            data: orderCounts,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'top'
            }
          },
          {
            name: '消费金额',
            type: 'line',
            data: totalAmounts,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top',
              formatter: val => this.formatAmountUnit(val.value)
            }
          }
        ]
      }

      this.chart.setOption(option)
    }
  }
}
</script>


<style scoped>
#customer-combined-chart {
  position: relative;
}

.empty-tip {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  font-size: 16px;
  background-color: #f5f7fa;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// CategoryBar.vue?d2afc1d0